import React, { useState } from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
import { useFreecodeContextData, useFreecodeContextRun } from 'hooks/useContext';
import ConfirmModal from 'components/Modals/confirmModal';
import { FreecodeButton } from 'components/Button/RectangleButton';
import { ObjectException } from 'global/errors';

const { FreecodeCreatorService } = services;

export default function ResetSolution() {
  const { testImpl, setTestImpl } = useFreecodeContextData();
  const { setCodeSol } = useFreecodeContextRun();

  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const resetSolution = () => {
    if (loading) return toast.error('Already loading');
    setLoading(true);

    const doConfirm = async () => {
      try {
        let response = await FreecodeCreatorService.resetDefaultSolution(testImpl.test, testImpl._id);
        if (response.error) throw new ObjectException(response.error?.message || 'Reset failed', 'response error');
        if (!response?.solution) throw new ObjectException('Response missing new solution', 'response error');

        setCodeSol(response.solution);
        setTestImpl((oldTestImpl) => ({ ...oldTestImpl, ...response }));
        toast.success('Solution has been reset');
        setViewModal(false);
      } catch (e) {
        toast.error(typeof e === 'string' ? e : e?.message || 'Could not reset');
      } finally {
        setLoading(false);
      }
    };
    doConfirm();
  };

  return (
    <>
      <FreecodeButton small isFreecodeButton floatRight onClick={() => setViewModal(true)}>
        Reset Solution
      </FreecodeButton>
      {viewModal && (
        <ConfirmModal
          isFreecodeModal
          title="Reset Solution"
          text="When resetting the solution all of your custom code will be lost. Do you want to continue?"
          onCancel={() => !loading && setViewModal(false)}
          onConfirm={resetSolution}
          loading={loading}
        />
      )}
    </>
  );
}
